export enum ActivityPageParams {
  activityHistoryUuid = "activityHistoryUuid",
  activityUuid = "activityUuid",
}
